/* eslint-disable */
import { Button, Flex, DatePicker, Select, Message, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import "../UserList.css";
import GanttChart from "./component/MonthlyChart";
import TicketChart from "./component/MonthlyTicketChart" 
import HeatmapChart from "./component/MonthlyTicketChart"
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
const { RangePicker } = DatePicker;
export default function MonthlyWorker() {
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);

  const [selectedAccount, setSelectedAccount] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [isSelectVisible, setIsSelectVisible] = useState(false);
  const childRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [apiData, setApiData] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [timeDate, setTimeDate] = useState(null);
  const [data, setData] = useState([]);

  
  // 时间戳转化
  const getCurrentMonthRange = (startTime, endTime) => {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0"); // 补零
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const toTimestamp = (dateString) => {
      return new Date(dateString).getTime();
    };
    return {
      startTime: toTimestamp(formatDate(new Date(startTime))),
      endTime: toTimestamp(formatDate(new Date(endTime))),
    };
  };

  // 时间选择

  const handleDateChange = (dates, dateStrings) => {
    setDateRange({
      startTime: dateStrings[0],
      endTime: dateStrings[1],
    });
  };

  const handleClick = () => {
    if (dateRange && selectedAccount) {
      // getMonthShow(dateRange.startTime, dateRange.endTime, selectedAccount);
      getShowClock(dateRange.startTime, dateRange.endTime, selectedAccount);
    } else {
      message.error("Please select a date range.");
    }
  };
  // 清除
  const handleClear = () => {
    setSelectedAccount(null);
    setIsSelectVisible(false);
  };

  const handleChangeUpdata = (value, e) => {
    setSelectedAccount(value);
    if (value.length > 0) {
      setSelectedAccount(value);
    } else {
      setApiData([]);
      setApiData([]);
    }
  };

  const stepSearchChange = (value) => {
    console.log("stepSearchChange", value);
    getSearchVendor(value);
  };
  const getSearchVendor = async (content) => {
    try {
      const Maintenance = "Maintenance";
      const requestContent = content === undefined ? "" : content;
      const response = await http.get(
        `${api.getMaintenanceVendor}?content=${encodeURIComponent(requestContent)}&vendorType=${Maintenance}`
      );
      if (response && response.data) {
        const formattedData = response.data.map((item) => ({
          value: item.vendorId,
          label: item.name,
        }));
        setAccountData(formattedData);
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
      setLoading(false);
    }
  };

  // 甘特图数据请求
  const getMonthShow = async (startTime, endTime, vendorIds) => {
    try {
      const timestamps = getCurrentMonthRange(startTime, endTime);
      const params = {
        startTime: timestamps.startTime,
        endTime: timestamps.endTime,
        idList: vendorIds,
        // idList:[36328]
      };
      const response = await http.post(api.showMonthlyWorker, params);
      if (response && response.data) {
        setData(response.data);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  // 日历打卡图表数据请求
  const getShowClock = async (startTime, endTime, vendorIds) => {
    setTableLoading(true);
    try {
      const timestamps = getCurrentMonthRange(startTime, endTime); 
      console.log("timestamps:", timestamps); 
      setTimeDate(timestamps)
      const queryParams = new URLSearchParams({
        sTime: timestamps.startTime,
        eTime: timestamps.endTime,
        vendorId: vendorIds,
      });
        
      console.log('queryParams:', queryParams.toString()); // 检查查询参数
      
      const response = await http.get(
        `${api.getVendorShowClock}?${queryParams.toString()}`
      );
      if (response && response.data) {
        console.log('dateList:',response);
        setData(response.data);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
      setTableLoading(false);
    }
  };


  // 使用 useEffect 在页面加载时执行方法
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    if (storedUser) {
      const userObject = JSON.parse(storedUser);
      setUser(userObject);
    }
    if (token) {
      setTimeout(() => {
        getSearchVendor();
      }, 1000);
    } else {
      console.error("未找到 token，无法获取数据");
      setLoading(false);
    }
  }, []);
  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div className="topLeft">
          <Select
            mode="multiple"
            style={{ width: 500, marginLeft: "10px", textAlign: "left"}}
            placeholder="Select Vendor"
            optionFilterProp="children"
            onChange={handleChangeUpdata}
            onClear={handleClear}
            
            onSearch={stepSearchChange}
            allowClear
            onBlur={() => setIsSelectVisible(false)}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            value={selectedAccount}
            options={accountData}
          />
          <div style={{ marginLeft: "20px" }}>
            <RangePicker onChange={handleDateChange} format="YYYY-MM-DD" />
          </div>
          <Button
            type="primary"
            onClick={handleClick}
            loading={tableLoading}
            style={{ marginLeft: "20px" }}
          >
            ‌Submit
          </Button>
        </div>
      </Flex>

      {/* {data ? (
        <GanttChart data={data} timeList={dateRange} />
      ) : (
        <p>Loading...</p>
      )} */}
{/* customData */}
         {data ? (
        <HeatmapChart data={data} timeList={dateRange} timestamps={timeDate} />
      ) : (
        <p>Loading...</p>
      )}
      
    </div>
  );
}
